import { render } from "./AssignAdvisor.vue?vue&type=template&id=1c79b4e4"
import script from "./AssignAdvisor.vue?vue&type=script&lang=js"
export * from "./AssignAdvisor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__